import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notification-panel" }
const _hoisted_2 = { class: "header-notification" }
const _hoisted_3 = { class: "header-item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "scroll" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "date" }
const _hoisted_8 = {
  key: 1,
  class: "notifications-list empty-notification"
}
const _hoisted_9 = { class: "label" }

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";
  import apiClient from "@/services/api";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import FormattedDate from "@/components/_partials/FormattedDate.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsPanel',
  props: {
    isMobileMenuProp: { type: Boolean, default: false }
  },
  emits: ["closePanel"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;

  const props = __props;

  const auctionStore = useAuctionStore();
  const notificationsLink = computed(() => auctionStore.routes["profile.notifications.edit"]);
  const notifications = computed(() => auctionStore.notifications);

  const clearAll = () => {
    apiClient
      .post("/api/notifications/mark-all-as-read")
      .then((response) => {
        if (response.data.success) {
          this.$store.commit("setNotifications", []);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const closePanel = () => {
    emit("closePanel");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", { href: notificationsLink.value }, _cache[0] || (_cache[0] = [
          _createElementVNode("svg", { class: "icon-settings" }, [
            _createElementVNode("use", { href: "/sprite.svg#settings" })
          ], -1)
        ]), 8, _hoisted_4),
        (notifications.value.length)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "#",
              class: "clear-all",
              onClick: _withModifiers(clearAll, ["prevent"])
            }, _toDisplayString(_unref(trans)("header.notifications.clear_all")), 1))
          : _createCommentVNode("", true),
        (props.isMobileMenuProp)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "close-button",
              onClick: closePanel
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("svg", { class: "icon-close" }, [
                _createElementVNode("use", { href: "/sprite.svg#close" })
              ], -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (notifications.value.length)
        ? (_openBlock(), _createBlock(CustomScrollbar, {
            key: 0,
            class: "notifications-list custom-scrollbar"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notification.id,
                  class: "notification-item"
                }, [
                  _createElementVNode("div", {
                    class: "message",
                    innerHTML: notification.content
                  }, null, 8, _hoisted_6),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(FormattedDate, {
                      class: "time",
                      "moment-js-format": "MMM D",
                      "utc-date": notification.created_at
                    }, null, 8, ["utc-date"])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(trans)("header.notifications.not_notifications")), 1)
          ]))
    ])
  ]))
}
}

})